import { useParams } from 'react-router-dom';
import React, { memo, useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { useUseCaseStore } from 'src/store/useUseCaseStore';
import { DescriptionSection } from './sections/DescriptionSection';
import { DetailsSection } from './sections/DetailsSection';
import { EditorBar } from './EditorBar';
import { isConsultantUser, isReadOnly } from '../../../auth/scope';
import { DetailsTabNav } from './sections/DetailsTabsNav';
import { ScrollToTop } from './ScrollToTop';
import { PreviousPageButton } from './controls/PreviousPageButton';
import SpinnerUI from 'src/components/common/Spinner';
import { useCustomerSelectorMode } from '../UserSelector/useCustomerSelectorMode';

export const UseCaseDetails = memo(function UseCaseDetails() {
  const { useCaseId } = useParams();
  const getUseCase = useUseCaseStore(state => state.getUseCase);
  const getUseCases = useUseCaseStore(state => state.getAllUseCases);
  const { customerMode } = useCustomerSelectorMode();
  const isUseCase = useUseCaseStore(state => state.isUseCase);
  const useCases = useUseCaseStore().useCases;
  const createEmptyUseCase = useUseCaseStore(state => state.createEmptyUseCaseDTO);

  const dataIsLoading = useUseCaseStore(state => state.isLoading);

  const readOnly = isReadOnly();

  useEffect(() => {
    if (!useCases.length) getUseCases();
    else {
      if (isUseCase(useCaseId)) getUseCase(useCaseId);
      else createEmptyUseCase(useCaseId);
    }
  }, [useCaseId, customerMode.mode, customerMode.id]);

  if (dataIsLoading) return <SpinnerUI />;

  return (
    <Box>
      {customerMode && <DetailsTabNav />}
      <PreviousPageButton url={'/usecases'} />
      <DescriptionSection />
      <DetailsSection />
      <ScrollToTop />
      {(!readOnly || isConsultantUser()) && <EditorBar />}
    </Box>
  );
});
